import { useCallback } from 'react';
import cross from '~/assets/icons/cross.svg';
import success from '~/assets/icons/success.svg';
import {
	setDoneVisible,
	setItemPageVisible,
	useLayoutDispatch,
} from '../../redux';
import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledButton,
	StyledCrossButton,
} from './AppAdsDoneScreen.styled';

const AppAdsDoneScreen = () => {
	const dispatch = useLayoutDispatch();

	const handleShowAd = useCallback(() => {
		dispatch(setDoneVisible(false));
		dispatch(setItemPageVisible(true));
	}, []);

	const handleClose = useCallback(() => {
		dispatch(setDoneVisible(false));
	}, []);

	return (
		<StyledContainer>
			<img src={success} />
			<TextLabel>Ваше объявление успешно опубликовано!</TextLabel>
			<StyledButton onClick={handleShowAd}>Открыть объявление</StyledButton>
			<StyledCrossButton onClick={handleClose}>
				<img src={cross} />
			</StyledCrossButton>
		</StyledContainer>
	);
};

export { AppAdsDoneScreen };
